import { useState, useEffect } from 'react';

/** Alinhado ao breakpoint `lg` do Tailwind (1024px). */
const MOBILE_MQ = '(max-width: 1023px)';

// `'ontouchstart' in window` NÃO é usado aqui de propósito: navegadores
// baseados em Android (ex: Silk, da Fire TV Stick) declaram esse evento na
// API mesmo em dispositivos sem hardware de toque nenhum — dá falso-positivo
// confirmado em produção. `navigator.maxTouchPoints` reflete o hardware de
// verdade e é a API recomendada pra essa checagem.
function hasTouchSupport(): boolean {
  return typeof window !== 'undefined' && navigator.maxTouchPoints > 0;
}

function queryMatches(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches && hasTouchSupport();
}

/**
 * Viewport de celular/tablet — o Player TV não deve abrir em tela cheia aqui.
 *
 * Exige viewport estreita E capacidade de touch. Algumas TV Boxes (ex: Fire TV
 * Stick 4K com o navegador Silk) aplicam DPI alto por causa do "10-foot UI"
 * (texto legível a distância) e acabam reportando viewport CSS estreita
 * mesmo sendo uma TV de verdade — mas nunca têm touch, já que são
 * controladas por controle remoto. Sem esse segundo sinal, essas TVs caíam
 * incorretamente no gate de mobile.
 */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(queryMatches);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const onChange = () => setIsMobile(mq.matches && hasTouchSupport());
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
